import {get} from 'lodash';
import store from '../store';
import Message from './message.service';
import User from '../api/user';

const Bus = {
  channel: null,
  messageListener: null
};

function onLocalChange(local) {
  store.commit('setLocal', local);
}

async function onMessage(data) {
  if (!(get(data, 'channel') === Bus.channel)) return;
  if (get(data, 'message') === 'DELETE') return onLocalChange(false);
  if (get(data, 'message.updatedAt')) return onLocalChange(true);
}

async function setup() {
  const local = await User.isLocalRunning();
  const {isLocalRunning, listen} = local;
  onLocalChange(isLocalRunning);

  Bus.channel = listen;
  Bus.messageListener = {
    message: onMessage
  };
  await Message.subscribe(Bus.channel, Bus.messageListener, 'system-bus');
}

async function destroy() {
  if (Bus.channel) await Message.unsubscribe(Bus.channel, Bus.messageListener, 'system-bus');
}

export default {setup, destroy};
